import { gql } from '@apollo/client'

const REDEEMED_DISCOUNT_CODE = gql`
  query RedeemedDiscountCodeQuery {
    user {
      id
      subscription {
        id
        alreadyRedeemedReactivationCampaign {
          name
          expiryDate
          description
          discountCode {
            id
            discountCodeParts {
              discountBasis
              value
              discountType
              n
            }
          }
        }
      }
    }
  }
`

export { REDEEMED_DISCOUNT_CODE }
